import { Head, router } from "@inertiajs/react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Separator,
  Text,
} from "@radix-ui/themes";
import { Users } from "lucide-react";

interface Invitation {
  id: number;
  team_name: string;
  location: string | null;
}

interface Props {
  invitation: Invitation;
}

export default function TeamInvitationShow({ invitation }: Props) {
  function accept() {
    router.patch(`/team_invitations/${invitation.id}/accept`);
  }

  function decline() {
    if (confirm("Are you sure you want to decline this invitation?")) {
      router.delete(`/team_invitations/${invitation.id}`);
    }
  }

  return (
    <>
      <Head title={`Invitation — ${invitation.team_name}`} />
      <Flex align="center" justify="center" style={{ minHeight: "100vh", padding: "2rem" }}>
        <Box style={{ maxWidth: 420, width: "100%" }}>

          <Flex align="center" justify="center" mb="5">
            <Flex align="center" justify="center"
              style={{
                width: 56, height: 56, borderRadius: "50%",
                background: "var(--accent-3)", color: "var(--accent-11)",
              }}
            >
              <Users size={26} />
            </Flex>
          </Flex>

          <Heading align="center" size="6" mb="2">
            You've been invited
          </Heading>
          <Text align="center" as="p" size="2" color="gray" mb="5">
            You have a pending invitation to join a team on Driftables.
          </Text>

          <Box
            p="4"
            style={{
              background: "var(--gray-2)",
              border: "1px solid var(--gray-5)",
              borderRadius: "var(--radius-3)",
              marginBottom: "var(--space-5)",
            }}
          >
            <Text size="3" weight="medium" as="p">{invitation.team_name}</Text>
            {invitation.location && (
              <Text size="2" color="gray" as="p" mt="1">{invitation.location}</Text>
            )}
          </Box>

          <Separator size="4" mb="5" />

          <Text size="2" color="gray" as="p" mb="5">
            Accepting means you'll appear on this team's roster and can be listed
            as a team member on event applications. You can leave the team at any
            time from your profile.
          </Text>

          <Flex direction="column" gap="2">
            <Button size="3" onClick={accept} style={{ width: "100%" }}>
              Accept invitation
            </Button>
            <Button size="3" variant="soft" color="gray" onClick={decline} style={{ width: "100%" }}>
              Decline
            </Button>
          </Flex>

        </Box>
      </Flex>
    </>
  );
}
